module.exports = __webpack_public_path__ + "img/function-009.9ad5b17d.png";